import styled from "@emotion/styled";
import { DESKTOP } from "@/themes/device";
import {
  grayScale,
  mBody1,
  mBody2,
  mBody3,
  mBody4,
  mCaption1,
  mHeader0,
  mHeader1,
  mTitle1,
  mTitle2,
  mTitle3,
  sparta,
  swc,
  wBody1,
  wBody2,
  wBody3,
  wBody4,
  wCaption1,
  wHeader2,
  wTitle4,
  wTitle5,
} from "@teamsparta/design-system";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: calc(100% - 32px);
  ${DESKTOP} {
    flex-direction: row;
    justify-content: space-between;
    width: initial;
    max-width: 960px;
    padding: 0;
  }
`;

export const TextSection = styled.section`
  margin-bottom: 50px;
`;

export const Title = styled.h3`
  ${mHeader1};
  margin: 0 0 10px 0;
  ${DESKTOP} {
    padding: 0;
    ${wHeader2};
    margin: 0 0 16px 0;
    text-align: left;
  }
`;

export const SubTitle = styled.h4`
  ${mBody2};
  color: ${grayScale.gray70};
  margin-bottom: 20px;

  ${DESKTOP} {
    ${wTitle5};
    color: ${grayScale.gray70};
    margin-bottom: 24px;
  }
`;

export const BenefitTitleSection = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const BenefitTitle = styled.strong`
  ${mBody3};
  color: ${grayScale.gray90};
  ${DESKTOP} {
    ${wBody3};
    color: ${grayScale.gray90};
    font-weight: 600;
  }
`;

export const BenefitList = styled.ul`
  margin: 8px 0 0;
  padding: 0 0 0 36px;
`;

export const Benefit = styled.li`
  ${mCaption1};
  color: ${grayScale.gray70};

  ${DESKTOP} {
    ${wCaption1};
    color: ${grayScale.gray70};
  }
`;

export const PriceCard = styled.article`
  width: 100%;
  border: 1px solid ${grayScale.gray30};
  border-radius: 12px;
  padding: 24px;

  ${DESKTOP} {
    max-width: 470px;
    padding: 30px;
  }
`;

export const CourseWeek = styled.small`
  width: 80px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${mBody3};
  color: ${grayScale.white};
  background-color: ${grayScale.gray100};
  border-radius: 100px;
  margin-bottom: 20px;

  ${DESKTOP} {
    ${wBody3};
    color: ${grayScale.white};
  }
`;

export const OriginalPrice = styled.del`
  ${mTitle3};
  font-size: 18px;
  color: ${grayScale.gray70};
`;

export const PriceSection = styled.p`
  display: flex;
  gap: 12px;
  align-items: center;
  margin: 4px 0 16px 0;
  ${DESKTOP} {
    margin: 4px 0 6px 0;
  }
`;

export const DiscountPrice = styled.strong`
  ${mHeader0};
  color: ${grayScale.gray100};
  ${DESKTOP} {
    ${wHeader2};
    color: ${grayScale.gray100};
  }
`;

export const EarlyBirdeBadge = styled.small`
  height: 28px;
  display: flex;
  align-items: center;
  ${mCaption1};
  color: ${swc.blue};
  background-color: ${sparta.blue10};
  padding: 5px 10px;
  border-radius: 8px;

  ${DESKTOP} {
    ${wCaption1};
    color: ${swc.blue};
  }
`;

export const InstallmentPrice = styled.small`
  ${mBody2};
  color: ${grayScale.gray90};

  ${DESKTOP} {
    ${wBody2};
    color: ${grayScale.gray80};
  }

  strong {
    ${mTitle2};
    color: ${grayScale.gray100};

    ${DESKTOP} {
      color: ${grayScale.gray80};
    }
  }
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${grayScale.gray30};
  margin: 20px 0;

  ${DESKTOP} {
    margin: 24px 0;
  }
`;

export const InstallmentInfoTitleSection = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const InstallmentInfoTitle = styled.strong`
  display: flex;
  align-items: center;
  ${mBody1};
  color: ${swc.blue};
  font-weight: 700;
  line-height: normal;

  ${DESKTOP} {
    ${wBody1};
    color: ${swc.blue};
  }
`;

export const CardIconWrapper = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
  margin-right: 10px;

  ${DESKTOP} {
    width: 24px;
    height: 24px;
  }
`;

export const CardCompanyList = styled.small`
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  ${mBody3};
  color: ${grayScale.gray70};
  cursor: pointer;
`;

export const CardCompaniesImage = styled.div`
  position: absolute;
  width: 301px;
  height: 221px;
  bottom: 5px;
  right: -36px;
`;

export const InstallmentDesc = styled.p`
  ${mBody4};
  color: ${grayScale.gray80};
  font-weight: 500;
  margin-left: 28px;

  ${DESKTOP} {
    margin-left: 34px;
  }
`;

export const MobileBr = styled.br`
  display: block;
`;

export const DesktopBr = styled.br`
  display: none;
`;
